import {
  createBrowserRouter,
} from 'react-router-dom';

import App from './containers/App';
import ErrorPage from './containers/ErrorPage';
//import MyAccountPage from './containers/MyAccountPage';
import TermsOfUsePage from './containers/TermsOfUsePage';
import config from './client/config';
//import { RequireAuth } from './hooks/useAuthGuard';
import MsoSelectPage from './containers/MsoSelectPage';
import ErrorClientPage from './containers/ErrorClientPage';
import DeviceLimitPage from './containers/DeviceLimitPage';

const router = createBrowserRouter(
  [
    {
      element: <App />,
      errorElement: <ErrorPage />,
      id: 'root',
      path: '/'
    },
    {
      element:  <ErrorClientPage />,
      path: `${config.clientShortName}/error/:errorCode`
    },
    {
      element : <MsoSelectPage />,
      path: `:cp/mso`
    },
    {
      element: <DeviceLimitPage/>,
      path: `${config.clientShortName}/devices/limit`
    },
    {
      element: <TermsOfUsePage />,
      path: `${config.clientShortName}/:cp/termsofuse`
    }
  ]
);

export default router;
